import { useMemo } from "react";
import { useFlags } from "src/components/Providers/FeatureFlagProvider";
import { SearchAndFilterTypes } from "src/constants";
import { useRemoteDataQuery } from "src/hooks/useRemoteDataQuery";
import * as GQL from "src/types/graphql";
import { GET_TAGS_FOR_FILTERS } from "../../graphql/queries";
import {
  CommonFilterProps,
  FormFilter,
  MultiSelectFilter,
} from "../CommonFilters";

type TagFilterProps = {
  enrollmentPeriodId: uuid;
  formTemplateId: uuid;
} & CommonFilterProps;

export const TagFilter: React.FC<TagFilterProps> = ({
  enrollmentPeriodId,
  formTemplateId,
  ...props
}) => {
  const flags = useFlags(["tags-exclusion-filter"]);

  const { remoteData: tagGroupsRemoteData } = useRemoteDataQuery<
    GQL.GetTagsForFilters,
    GQL.GetTagsForFiltersVariables
  >(GET_TAGS_FOR_FILTERS, {
    skip: !enrollmentPeriodId,
    variables: {
      enrollment_period_id: enrollmentPeriodId,
    },
    fetchPolicy: "cache-and-network",
  });

  const options = useMemo(
    () =>
      tagGroupsRemoteData.toNullable()?.enrollment_period_tag.map((tag) => ({
        id: tag.id,
        label: tag.name,
        group: tag.tag_group?.name ?? undefined,
      })) ?? [],
    [tagGroupsRemoteData]
  );
  return (
    <FormFilter label="Tags">
      <MultiSelectFilter
        options={options}
        filterKey={SearchAndFilterTypes.Tag}
        placeholder="Type a tag"
        negatable={flags["tags-exclusion-filter"].enabled}
        {...props}
      />
    </FormFilter>
  );
};
